import apiFetch from '../services/apiFetch';

// One authenticated API call. Resolves with the parsed body or rejects with
// an Error carrying the server message and, for validation failures, the
// full `errors` list.
export default async function call(path, token, options) {
    const res = await apiFetch(path, token, options);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const errors = data.errors || [];
        const error = new Error(errors.join('; ') || data.message || `Request failed (${res.status})`);
        error.errors = errors;
        error.status = res.status;
        throw error;
    }
    return data;
}

export const json = (method, body) => ({ method, body: JSON.stringify(body) });
